export const ACTION = {
  VALIDATION_CHANGE: 'PROFILE:VALIDATION_CHANGE'
};

export class ValidationChange {

  public type: string = ACTION.VALIDATION_CHANGE;
  public validation: any;

  constructor(validation: any) {
    this.validation = validation;
  }
}
